/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Faq_A6Inputs */

const en_minifier_faq_a6 = /** @type {(inputs: Minifier_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Whitespace between tokens is insignificant in JSON, so removing it produces a document that any conforming parser reads identically. The only cost is readability.`)
};

const ko_minifier_faq_a6 = /** @type {(inputs: Minifier_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그렇습니다. JSON에서 토큰 사이의 공백은 의미가 없으므로, 제거해도 규격을 지키는 어떤 파서든 동일하게 읽습니다. 대가는 가독성뿐입니다.`)
};

const ja_minifier_faq_a6 = /** @type {(inputs: Minifier_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。JSON ではトークン間の空白に意味がないため、取り除いても規格に従うどのパーサも同じように読みます。代償は可読性だけです。`)
};

/**
* | output |
* | --- |
* | "Yes. Whitespace between tokens is insignificant in JSON, so removing it produces a document that any conforming parser reads identically. The only cost is re..." |
*
* @param {Minifier_Faq_A6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_faq_a6 = /** @type {((inputs?: Minifier_Faq_A6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Faq_A6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_faq_a6(inputs)
	if (locale === "ko") return ko_minifier_faq_a6(inputs)
	return ja_minifier_faq_a6(inputs)
});